<template>
  <div class="bg-gray-21 p-3">
    <div class="d-flex justify-content-end">
      <action-button
        class="btn-warning-outline px-4 py-2 mr-2"
        :text="$t('GoBack')"
        i="fa fa-arrow-circle-left"
        @click="$router.go(-1)"
      />

      <action-button
        class="btn-success px-4 py-2"
        :text="$t('ChangeQuestionButtonText')"
        i="fa fa-save"
        @click="onSaveHandler"
      />

      <!-- <action-button
        class="warning px-3 py-2"
        i="fa fa-exclamation-circle"
        :text="$t('GenerateReport.Title')"
        @click="onOpenGenerateReportModal"
      /> -->
    </div>
    <validation-observer ref="formRef" v-slot="{}" tag="form">
      <div class="bg-white rounded p-4 mt-4">
        <div class="d-flex align-items-center">
          <em class="fal fa-ellipsis-h color-orange-light-2 mr-3 font-40" />
          <span class="color-dark-blue font-14 font-weight-bold">
           Cambio de Rol
          </span>
        </div>
        <div class="row mt-3">
          <div class="col-md-5">
            <div class="color-primary-4 font-14 font-weight-bold mb-1">
              Rol:
            </div>
            <validation-provider rules="required" v-slot="{ errors }">
              <custom-drop-down
                label=""
                placeholder="Seleccione"
                :options="options.roles"
                fieldkey="id"
                fieldname="name"
                v-model="model.role"
                @input="() => {}"
                :error="errors[0]"
                :custom-error-msg="`${$t('RequiredField')}.`"
              />
            </validation-provider>
          </div>
      
   
        </div>
      </div>
    </validation-observer>

    <GenerateReportModal
      ref="generateReportModal"
      @close="onCloseGenerateReportModal"
      @accept="onOpenGenerateReportModal"
    />
  </div>
</template>

<script>
//TODO: (Move the component and instance to the right place)
import GenerateReportModal from '@/views/request/GenerateReportModal.vue';

//libs
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import CustomDropDown from 'custom-drop-down';

//services
import {
  updateRole ,
  getRoles ,
  getUserRole,
} from '@/services/app.api.js';

//mixins
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';
import { userMixin } from '@/mixins/user.mixin';

//utils
import { i18n, loadLanguageAsync } from '@/i18n.js';

//constants
import langTypes from '@/utils/constants/lang.js';
import { datetime } from '@/filters';

export default {
  name: 'ChangeRoleView',
  mixins: [alertMixin, userMixin],
  components: {
    ActionButton,
    CustomInput,
    CustomDropDown,
    GenerateReportModal,
  },
  props: {
    isNewProfile: {
      type: Boolean,
      default: true,
    },
    userProfileInformation: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    model: {
      //user account
      userId: null,
      role: null,
     
    },
    options: {
      roles: [],
    },
  }),
  computed: {
    isEnLang() {
      return this.userSelectedLang === langTypes.EN;
    },
  },
  async created() {
    loadLanguageAsync();
  },
  async mounted() {
    await this.getInitCreateAccount();
  },
  methods: {
    datetime,
    async getInitCreateAccount() {
       this.options.roles = (await getRoles()).data;
      const roleName =(await getUserRole(this.$route.params.userId)).data
      this.model.role=this.options.roles.find(role=> role.name==roleName);
      console.log(this.model.role);
    },

    async onSaveHandler() {
      const isValid = await this.$refs.formRef.validate();
      if (!isValid) {
        this.ShowToast(
          i18n.t('Alert'),
          `${i18n.t('PleaseCompleteRequestedInformation')}.`,
          'error'
        );
        return;
      }
      //get user id of route
      this.model.userId = this.$route.params.userId;
    

      const updateResponse = await updateRole(this.model.userId,this.model.role?.id).catch((error) =>
        this.ShowToast('Error', error.response.data.message, 'error')
      );
      if (updateResponse) {
        const response = updateResponse.data;
        if (response.error) {
          this.ShowToast('Alerta', response.message, 'error');
          return;
        }
        this.ShowToast(
          i18n.t('ProcessSuccessfully'),
          i18n.t('ProfileInformationSuccessfully'),
          'success'
        );
      }
    },
    //TODO: (Move the component and instance to the right place)
    onOpenGenerateReportModal() {
      if (this.$refs.generateReportModal) {
        this.$refs.generateReportModal.showModal();
      }
    },
    onCloseGenerateReportModal() {
      this.$refs.generateReportModal?.hideModal();
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';

.rb__extended ::v-deep {
  .col-12 {
    margin-left: -24px !important;
  }
}
</style>
